import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const WooCommerceWebsiteDevelopmentInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="WooCommerce Website Development in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Empower Your Online Store</Subheading>}
        heading={
          <Heading>
            WooCommerce <span tw="text-primary-500">Website Development</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset specializes in WooCommerce website development in
            **Al Barsha**, crafting flexible, user-friendly, and scalable online
            stores powered by WordPress. Start selling with confidence today.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // WooCommerce store setup
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce development
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose WooCommerce?</Subheading>}
        heading="Top WooCommerce Development in Al Barsha"
        description="We build stores that are versatile and easy to manage."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Custom Designs",
            description: "Tailored stores to match your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Launch quickly with WooCommerce.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Plugin Flexibility",
            description: "Access thousands of WordPress plugins.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description: "Safe checkout for your customers.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Friendly",
            description: "Seamless shopping on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Local Expertise",
            description: "Al Barsha’s trusted WooCommerce partner.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Build</Subheading>}
        heading="Our WooCommerce Development Process"
        description={
          <Description>
            We create your WooCommerce store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Align with your business goals.</li>
              <li>Design: Craft engaging, responsive layouts.</li>
              <li>Development: Integrate plugins and payment gateways.</li>
              <li>Testing: Ensure performance and usability.</li>
              <li>Launch: Deploy your store for success.</li>
              <li>Support: Provide ongoing updates and maintenance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="WooCommerce Wins in Al Barsha"
        description="Our stores drive growth and engagement."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Increased revenue by 130% in 3 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Launch",
            description: "Stores live in under 6 days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "96% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell?</Subheading>}
        heading="WooCommerce Website Development in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for expert WooCommerce website
            development in Al Barsha. Build a flexible, high-performing
            store—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape
          "https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce success
          "https://images.unsplash.com/photo-1577401239170-897942555fb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online store management
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
